/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_PropagationInputs */

const en_verify_propagation = /** @type {(inputs: Verify_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify Propagation`)
};

const es_verify_propagation = /** @type {(inputs: Verify_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificar propagación`)
};

const fr_verify_propagation = /** @type {(inputs: Verify_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifier la propagation`)
};

const de_verify_propagation = /** @type {(inputs: Verify_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbreitung überprüfen`)
};

const ja_verify_propagation = /** @type {(inputs: Verify_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`伝播を確認`)
};

const zh_verify_propagation = /** @type {(inputs: Verify_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证解析状态`)
};

const ar_verify_propagation = /** @type {(inputs: Verify_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحقق من الانتشار`)
};

const id_verify_propagation = /** @type {(inputs: Verify_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifikasi Propagasi`)
};

const it_verify_propagation = /** @type {(inputs: Verify_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica Propagazione`)
};

const ru_verify_propagation = /** @type {(inputs: Verify_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверить обновление`)
};

const pt_verify_propagation = /** @type {(inputs: Verify_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificar Propagação`)
};

const ko_verify_propagation = /** @type {(inputs: Verify_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전파 상태 확인`)
};

/**
* | output |
* | --- |
* | "Verify Propagation" |
*
* @param {Verify_PropagationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_propagation = /** @type {((inputs?: Verify_PropagationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_PropagationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_propagation(inputs)
	if (locale === "es") return es_verify_propagation(inputs)
	if (locale === "fr") return fr_verify_propagation(inputs)
	if (locale === "de") return de_verify_propagation(inputs)
	if (locale === "ja") return ja_verify_propagation(inputs)
	if (locale === "zh") return zh_verify_propagation(inputs)
	if (locale === "ar") return ar_verify_propagation(inputs)
	if (locale === "id") return id_verify_propagation(inputs)
	if (locale === "it") return it_verify_propagation(inputs)
	if (locale === "ru") return ru_verify_propagation(inputs)
	if (locale === "pt") return pt_verify_propagation(inputs)
	return ko_verify_propagation(inputs)
});